import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { Image } from '../Image';
import styles from './index.module.less';
// TODO: implement details
const defaultLogo = new URL('./default-collectible-logo.png', import.meta.url).href;
export const CollectionLogo = ({ className, sizes, ...rest }) => {
    return (_jsx("div", { className: classnames(className, styles.logo), ...rest, children: _jsx(Image, { src: defaultLogo, className: styles.image, sizes: sizes }) }));
};
